import React from 'react'
import { useAppointmentCalendar } from '@context/AppointmentCalendarContext/AppointmentCalendarContext'
import { useTranslation } from 'react-i18next'
import useStyles from './styles'
import { Button } from '@mui/material'
import { ToggleMoreClinicsIcon } from './ToggleMoreClinicsIcon'
import { TEST_IDS } from 'src/constants/testIds'

interface Props {
  toggleMoreClinicsButtonRef?: React.MutableRefObject<HTMLDivElement | null>
}

export const ToggleMoreClinicsButton = ({ toggleMoreClinicsButtonRef }: Props) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const { toggleMoreClinicsOpen, isMoreClinicsOpen } = useAppointmentCalendar()

  return (
    <div className={classes.toggleClinicsContainer} ref={toggleMoreClinicsButtonRef}>
      <Button
        fullWidth
        onClick={toggleMoreClinicsOpen}
        className={classes.toggleShowMoreClinics}
        variant="shadowed"
        data-test={TEST_IDS.toggleClinicsNearby}
      >
        {isMoreClinicsOpen ? t('less_appointments_nearby') : t('more_appointments_nearby')}
        <ToggleMoreClinicsIcon isExpanded={isMoreClinicsOpen} />
      </Button>
    </div>
  )
}
